<template>

    <PopupModel v-model="isOpen" description="Are You sure delete this record" heading="Delete Collection"
                @confirm="confirmDelete"/>
    <internal>
        <div class="relative p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
            <p class="text-lg font-medium absolute">Collections </p>

            <breeze-table
                :fields="[
                        {'key':'student','label':'Name'},
                        {'key':'amount','label':'Amount'},
                        {'key':'action','label':'action'},
                        ]"
                :items="items"
                :action="{
                        url:route('internal.collection.create',[branchId]),
                        text:'Create',
                    }"
                :canCreate="hasRole('Create Collection')"
                :canView="hasRole('View Collection')">
                <template #student="data">
                    {{ data.item?.student?.first_name }}
                    {{ data.item?.student?.middle_name }}
                    {{ data.item?.student?.last_name }}
                </template>
                <template #action="data">
                    <!-- {{data.item}} -->
                    <button-link
                        v-if="hasRole('Edit Collection')"
                        :href="route('internal.collection.edit',[branchId,data.item.id])">
                        Edit
                    </button-link>

                    <Button @click="deleteCollection(data.item);"
                            v-if="hasRole('Edit Collection')"
                            class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white ml-2 translate-y-1">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             class="w-4 h-4  justify-self-center cursor-pointer"
                             viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd"
                                  d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                  clip-rule="evenodd"></path>
                        </svg>
                    </Button>

                </template>

            </breeze-table>

        </div>
    </internal>
</template>
<script setup>
import Internal from '@/Pages/Internal/Internal'
import BreezeTable from '@/Components/Table'
import ButtonLink from '@/Components/ButtonLink'
import {computed, defineProps, ref} from "vue";
import {useForm, usePage} from '@inertiajs/inertia-vue3';
import PopupModel from "@/Components/PopupModel.vue";
import Button from "@/Components/Button.vue";
import {hasRole} from "../../../../Utils/checkPermission";

const isOpen = ref(false);
const props = defineProps({
    studentCollections: {
        type: Object,
        default: []
    },
})

const branchId = computed(() => localStorage.branchId);
const form = useForm([]);
const items = computed(()=>usePage().props.value?.studentCollections);
// const items = ref(props.studentCollections);
const id = ref('');

function deleteCollection(item) {
    isOpen.value = true;
    id.value = item.id;
}

function confirmDelete() {
    form.delete(route('internal.collection.destroy', [branchId.value, id.value]), {
        onSuccess: () => {
            isOpen.value = false;
        }
    });
}

// internal.collection.destroy
</script>
